// extracted by mini-css-extract-plugin
export const root = "initiatives-module--root--3k91b";